import * as React from "react";
import DeviceCreateForm from "../components/DeviceCreateForm";

export default function DeviceCreatePage() {
  return <DeviceCreateForm />;
}